import { composeAddress } from './address';
export function mapRoutes(deal = {}) {
  const lat = Number(deal.latitude), lng = Number(deal.longitude);
  const point = deal.latitude != null && deal.longitude != null && Number.isFinite(lat) && Number.isFinite(lng)
    && Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
  const address = composeAddress(deal.city?.name || '', deal.address || deal.full_address || '');
  if (!point && !address) return [];
  const target = point ? `${lat},${lng}` : address;
  return [
    { title: 'Яндекс Карты', url: `https://yandex.ru/maps/?rtext=${encodeURIComponent('~' + target)}&rtt=auto` },
    { title: '2ГИС', url: point ? `https://2gis.ru/routeSearch/rsType/car/to/${lng},${lat}` : `https://2gis.ru/search/${encodeURIComponent(address)}` },
    { title: 'Google Maps', url: `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(target)}&travelmode=driving` },
  ];
}
